<template>
    <ElDialog
        class="modal" 
        :visible.sync="showModal" 
        :width="modalWidth"
        :show-close="false"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
    >

        <h2 class="modal__title">
            {{ title }}
        </h2>
        <div class="modal__body">
            <p class="modal__text">
                {{ text }}
            </p>
        </div>
    </ElDialog>
</template>

<script>
import modal from "@/mixins/modal";
import BaseButton from '@/components/ui/BaseButton';

export default {
    name: 'ModalBlockError',
    props: {
        title: {
            type: String,
            required: true
        },
        text: {
            type: String,
            required: true
        }
    },
    mixins: [modal]
}
</script>